import { ArrowRight, Wand2 } from "lucide-react";
import { Link } from "react-router-dom";

export function CTA() {
  return (
    <section className="mx-auto max-w-4xl px-5 py-16 text-center sm:px-6 sm:py-24">
      <h2 className="mb-3 font-display text-2xl font-medium sm:mb-4 sm:text-3xl">
        まずは手元の 1 枚から
      </h2>
      <p className="mb-7 text-base text-[var(--color-ink-muted)] sm:mb-8 sm:text-lg">
        どんな .pptx / .pdf でも OK。ブラウザだけで試せます。
      </p>
      <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
        <Link
          to="/app"
          className="inline-flex h-12 items-center gap-2 rounded-[10px] bg-[var(--color-coral)] px-6 text-base font-medium text-white shadow-[var(--shadow-sm)] transition hover:bg-[var(--color-coral-dark)] hover:shadow-[var(--shadow-md)]"
        >
          アプリを開く <ArrowRight size={16} />
        </Link>
        <Link
          to="/app"
          state={{ autoSample: true }}
          className="inline-flex h-12 items-center gap-2 rounded-[10px] border border-[var(--color-border)] bg-[var(--color-surface)] px-6 text-base font-medium text-[var(--color-ink)] transition hover:bg-[var(--color-surface-muted)]"
        >
          <Wand2 size={16} />
          サンプルで試す
        </Link>
      </div>
    </section>
  );
}
